"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInformation = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var digitSeparator_1 = require("../../util/digitSeparator");
var ProductInformation = function (_a) {
    var productDatas = _a.productDatas;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Box, null,
            react_2.default.createElement(react_1.Text, { as: "h2", fontSize: "2.4rem", color: "#90c830" }, productDatas.name),
            productDatas.catchphrase && (react_2.default.createElement(react_1.Text, { fontSize: { base: "1.6rem" }, mt: "2rem" }, productDatas.catchphrase)),
            productDatas.sku && (react_2.default.createElement(react_1.Text, { fontSize: { base: "1.4rem" }, mt: "4rem" },
                "\u5546\u54C1\u30B3\u30FC\u30C9: ",
                productDatas.sku)),
            productDatas.sales_price_with_tax === null ? (react_2.default.createElement(react_1.Box, { mt: "1.5rem" },
                react_2.default.createElement(react_1.Text, { as: "span", color: "red", fontWeight: "bold", fontSize: {
                        base: "2.6rem",
                    } }, "\u53C2\u8003\u51FA\u54C1"))) : (react_2.default.createElement(react_2.default.Fragment, null, productDatas.sales_price_with_tax === 0 ? (react_2.default.createElement(react_2.default.Fragment, null)) : (react_2.default.createElement(react_1.Box, { mt: "1.5rem" },
                react_2.default.createElement(react_1.Text, { as: "span", color: "red", fontWeight: "bold", fontSize: {
                        base: "2.6rem",
                    } },
                    "\u00A5",
                    " ",
                    (0, digitSeparator_1.digitSeparator)(productDatas.sales_price_with_tax)),
                react_2.default.createElement(react_1.Text, { as: "span", fontWeight: "bold", fontSize: {
                        base: "1.4rem",
                    } }, "\uFF08\u7A0E\u8FBC\uFF09"))))))));
};
exports.ProductInformation = ProductInformation;
